import { Component } from '@angular/core';
import { APP_TITLE } from '../../constants/labels.const';

@Component({
  selector: 'ev-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  readonly title = APP_TITLE;
}
